// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ObservePage_wrapper_WLJ8n"};